import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { getHomeDetail } from "src/api/home";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetHomeSection = function() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _query_data;
    const { ipSelectSourceId  } = options;
    const router = useRouter();
    const { homeId , homeType , setHomeState  } = useHomeSwitchStore();
    const query = useQuery({
        queryKey: [
            QUERY_KEYS.HOME_SECTION,
            homeType,
            homeId,
            ipSelectSourceId
        ],
        queryFn: ()=>getHomeDetail({
                homeId,
                ipSelectSourceId
            }),
        enabled: !!homeId,
        keepPreviousData: true,
        select: (data)=>{
            const sectionsMap = data.sections.reduce((acc, section)=>{
                acc[section.sectionType] = section;
                return acc;
            }, {});
            return {
                ...data,
                sectionsMap
            };
        }
    });
    // API 응답의 home.type으로 homeType 동기화
    // - URL에 homeId 쿼리가 있을 때만 동기화 (토글 시에는 router.push로 쿼리가 제거됨)
    // - 응답의 homeId가 현재 homeId와 일치할 때만 동기화 (stale/previous 데이터 무시)
    useEffect(()=>{
        var _query_data;
        if (!((_query_data = query.data) === null || _query_data === void 0 ? void 0 : _query_data.home)) return;
        if (!router.query.homeId) return;
        if (query.data.home.homeId !== homeId) return;
        if (query.data.home.type !== homeType) {
            setHomeState(query.data.home.type, query.data.home.subject);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (_query_data = query.data) === null || _query_data === void 0 ? void 0 : _query_data.home,
        router.query.homeId
    ]);
    return query;
};
export default useGetHomeSection;
